<template>
  <NavView></NavView>
    <SideBar></SideBar>
  <div class="container-fluid" >
   
   
<div>
<!-- <h1>{{$route.params.id }}</h1> 
<h2>{{details.C_name}} my</h2> -->
<div   >

<nav class="navbar border1">
<h6 class="hmy pt-2 font1 font-bold1"> <router-link class="decoration" to="/customer/index"> All Customer </router-link><span class="pfimg1"><i class="fa fa-angle-right" aria-hidden="true"></i></span> {{ customer.C_name }} <span class="pfimg1"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{ customer.C_code }} </h6>
<!-- <p> {{detail.C_name}} ok</p> -->
<form class="d-flex">

<button class="btn btn-primary ms-1 btn-sm btn-border-radius border-radius0" type="submit">Add New Contact</button>
<button class="btn btn-primary ms-1 btn-sm border-radius0" type="submit">Inactive</button>
<router-link class=" btn btn-primary ms-1 btn-sm text-light border-radius0" to="/customer/index">Back</router-link> 
</form>
</nav>

<!-- <p class="clr2"><b> Details</b> </p> -->

<div class="row mt-2">
<div class="col-md-5 container-fluid">



<div class=" bg-light p-4">
  <table class="table font1 ">
    <tbody>
     
      <tr>
        <td >Customer Group</td>
        <td v-if="!isHidden1" class="eddit2">{{ customer.customer_type}} </td>
        <td v-else><input class="me-2" v-model="customer.customer_type"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden1 = false"></i> <i v-on:click="isHidden1 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>
        <td class="eddit1 eddit2" v-on:click="isHidden1 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></td>
      </tr>
      <tr class="">
        <td class="">Customer Name</td>
        <td v-if="!isHidden" class="eddit2"> {{ customer.C_name}}<br></td>
     
        <td v-else><input  class="me-2" v-model="customer.C_name"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden = false"></i> <i v-on:click="isHidden = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>
        <td class="eddit1 eddit2" v-on:click="isHidden = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td>
      </tr>
      <tr>
        <td >Frist Name</td>
        <td v-if="!isHidden2" class="eddit2">{{ customer.C_firstname}} </td>
        <td v-else><input class="me-2" v-model="customer.C_firstname"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden2 = false"></i> <i v-on:click="isHidden2 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>
        <td class="eddit1 eddit2" v-on:click="isHidden2 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td>
      </tr>
      <tr>
        <td >Last Name</td>
        <td v-if="!isHidden3" class="eddit2"> {{ customer.C_lastname}}</td>
        <td v-else><input class="me-2" v-model="customer.C_lastname"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden3 = false"></i> <i v-on:click="isHidden3 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>
        <td class="eddit1 eddit2" v-on:click="isHidden3 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td>
      </tr>
      <tr>
        <td >district</td>
        <td v-if="!isHidden11" class="eddit2">  {{ customer.district}}</td>
        <td v-else><input class="me-2" v-model="customer.district"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden11 = false"></i> <i v-on:click="isHidden11 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
        <td class="eddit1 eddit2" v-on:click="isHidden11 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td>       
       </tr>
     
      
      <tr>
        <td >NRIC</td>
        <td v-if="!isHidden7" class="eddit2">  {{ customer.nic_no}}</td>
        <td v-else><input class="me-2" v-model="customer.nic_no"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden7 = false"></i> <i v-on:click="isHidden7 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
        <td class="eddit1 eddit2" v-on:click="isHidden7 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td>
      
      </tr>
      <tr>
        <td >Driving Licence No</td>
        <td v-if="!isHidden8" class="eddit2">  {{ customer.driving_license}}</td>
        <td v-else><input class="me-2" v-model="customer.driving_license"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden8 = false"></i> <i v-on:click="isHidden8 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
        <td class="eddit1 eddit2" v-on:click="isHidden8 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td>
      </tr>
    </tbody>
  </table>
    
      <!-- Tabs navs -->
      
      <!-- Tabs content -->
      <div class="tab-content" id="ex1-content">
      
      <div class="tab-pane fade show active" id="ex1-tabs-" role="tabpanel" aria-labelledby="ex1-tab-1" >
      <div class=" bg-light ">
      <table class="table font1">
        <tbody>
          <tr>
            
          <th>Customer Name</th>
          <th>designation</th>
          <th>email</th>
          <th>phone</th>
         
       
        </tr>
          <tr v-for="(detail4, index) in details4" :key="detail4.id_customer">
            <!-- v-for="(detail4, index) in details4" :key="detail4.id_customer" -->
            <td v-if="!isHidden28" class="eddit2">{{detail4.name}}</td>
            <td v-else><input class="me-1 width4" v-model="contact[index].name" ></td>  
            <td v-if="!isHidden28" class="eddit2">{{detail4.designation}}</td>
            <td v-else><input class="me-1 width4" v-model="contact[index].designation" ></td>      
            <td  v-if="!isHidden28" class="eddit2">{{detail4.email}}</td>
            <td v-else><input class="me-1 width4" v-model="contact[index].email"></td>      
            <td v-if="!isHidden28" class="eddit2">{{detail4.tel}}</td>
            <td v-else><input class="me-1 width4" v-model="contact[index].tel"><i class="fa fa-check me-1 pointer1" aria-hidden="true"  v-on:click="update3(detail4.id)"  @click="isHidden28 = false"></i> <i v-on:click="isHidden28 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
            <td class="eddit1 eddit2" ><i class="fa fa-pencil-square-o me-2" v-on:click="isHidden28 = true" aria-hidden="true"></i>  <i class="fa fa-plus me-2" v-on:click="isHidden30 = true" aria-hidden="true"></i><i class="fa fa-minus "  v-on:click="Delete(detail4.id)" aria-hidden="true"></i> </td>
           
          </tr>
          <tr v-if="isHidden30">
            <td><input class="me-1 width4" v-model="create.name" ></td>
            <td><input class="me-1 width4" v-model="create.designation" ></td>
            <td><input class="me-1 width4" v-model="create.email" ></td>
            <td><input class="me-1 width4" v-model="create.tel" ></td>
            <td class="pt-1"><i class="fa fa-check me-1 pointer1" aria-hidden="true" @click="isHidden30 = false" v-on:click="Create($route.query.data)" ></i> <i v-on:click="isHidden30 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
          </tr>
          
        </tbody>
      </table>
      </div>
      </div>
      
     
      
      </div>




</div>
<br>
<nav class="navbar navbar-light bg-light">
  <div class="container-fluid font1 font-bold1">
    <span>Address Details</span>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent1" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fa fa-chevron-down" aria-hidden="true"></i>
    </button>
    
  </div>
</nav>
<div class="collapse" id="navbarToggleExternalContent1">
  <div class="bg-light p-4">
    <table class="table font1">
      <tbody>
        <tr>
          <td >Contact Name</td>
          <td v-if="!isHidden9" class="eddit2"> {{ customer.C_contact_person}}</td>
          <td v-else><input class="me-2" v-model="customer.C_contact_person"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden9 = false"></i> <i v-on:click="isHidden9 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
          <td class="eddit1 eddit2" v-on:click="isHidden9 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        
       
       
      </tbody>
    </table>
   <!-- -->
   <ul class="nav nav-tabs mb-3" id="ex1" role="tablist">
    <li class="nav-item" role="presentation">
      <a
        class="nav-link active font1 font-bold1"
        id="ex1-tab-0"
        data-bs-toggle="tab"
        href="#ex1-tabs-1"
        role="tab"
        aria-controls="ex1-tabs-1"
        aria-selected="true"
        >Shipping address</a
      >
    </li>
    <li class="nav-item" role="presentation">
      <a
        class="nav-link font1 font-bold1"
        id="ex1-tab-2"
        data-bs-toggle="tab"
        href="#ex1-tabs-2"
        role="tab"
        aria-controls="ex1-tabs-2"
        aria-selected="false"
        >Billing address</a
      >
    </li>
    
    
    </ul>
    <!-- Tabs navs -->
    
    <!-- Tabs content -->
    <div class="tab-content" id="ex1-content">
    
    <div class="tab-pane fade show active" id="ex1-tabs-1" role="tabpanel" aria-labelledby="ex1-tab-1" >
    <div class=" bg-light p-4">
    <table class="table font1">
      <tbody >
        <tr v-show="detail.address_type === 'Shipping address'" v-for="(detail, index) in details" :key="detail.address_type" > 
          <td>address {{index+1}}</td>
          <td v-if="!isHidden27" class="eddit2">{{detail.address_line_1}}</td>
          <td v-else><input class="me-2 width4" v-model="address.address_line_1" ></td>      
          <td  v-if="!isHidden27" class="eddit2">{{detail.address_line_2}}</td>
          <td v-else><input class="me-2 width4" v-model="address.address_line_2" ></td>      
          <td v-if="!isHidden27" class="eddit2">{{detail.address_line_3}}</td>
          <td v-else><input class="me-2 width4" v-model="address.address_line_3"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="update(detail.id)"  @click="isHidden27 = false"></i> <i v-on:click="isHidden27 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
          <td class="eddit1 eddit2" v-on:click="isHidden27 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        
        
      </tbody>
    </table>
    </div>
    </div>
    <div class="tab-pane fade" id="ex1-tabs-2" role="tabpanel" aria-labelledby="ex1-tab-2">
      <div class=" bg-light p-4">
        <table class="table font1">
          <tbody>
            <tr v-show="detail.address_type === 'Billing address'"  v-for="(detail, index) in details" :key="detail.address_type" > 
              <td>address {{index+1}}</td>
              <td v-if="!isHidden26" class="eddit2">{{detail.address_line_1}}</td>
              <td v-else><input class="me-2 width4" v-model="address.address_line_1"></td>      
              <td v-if="!isHidden26" class="eddit2">{{detail.address_line_2}}</td>
              <td v-else><input class="me-2 width4" v-model="address.address_line_2"></td>      
              <td v-if="!isHidden26" class="eddit2">{{detail.address_line_3}}</td>
              <td v-else><input class="me-2 width4" v-model="address.address_line_3" ><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="update(detail3.id)"  @click="isHidden26 = false"></i> <i v-on:click="isHidden26 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
              <td class="eddit1 eddit2" v-on:click="isHidden26 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </td>
            </tr>
            
          </tbody>
        </table>
     </div>
    </div>
   
    
    </div>



  </div>
</div>
<br>
<nav class="navbar navbar-light bg-light">
  <div class="container-fluid font1 font-bold1">
    <span>Bank Details</span>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent2" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fa fa-chevron-down" aria-hidden="true"></i>
    </button>
    
  </div>
</nav>
<div class="collapse" id="navbarToggleExternalContent2">
  <div class="bg-light p-4">
   
    <!-- Tabs start -->

  
  
      
      <!-- Tabs content -->
      <div class="tab-content" id="ex1-content">
      
      <div class="tab-pane fade show active" id="ex1-tabs-11" role="tabpanel" aria-labelledby="ex1-tab-1" >
      <div class=" bg-light ">
      <table class="table font1">
        <tbody>
          <tr>
          
          <th>Bank name</th>
          <th>Branch</th>
          <th>Acount Nuumber</th>
       
        </tr>
          <tr  v-for="detail5 in details5" :key="detail5">
          
            
            <td v-if="!isHidden29" class="eddit2">{{detail5.bank_name}}</td>
            <td v-else><input class="me-1 width4" v-model="bank.bank_name" ></td>      
            <td  v-if="!isHidden29" class="eddit2">{{detail5.branch}}</td>
            <td v-else><input class="me-1 width4" v-model="bank.branch"></td>      
            <td v-if="!isHidden29" class="eddit2">{{detail5.acount_num}}</td>
            <td v-else><input class="me-1 width4" v-model="bank.acount_num"><i class="fa fa-check me-1 pointer1" aria-hidden="true"  v-on:click="update4(detail5.id)"  @click="isHidden29 = false"></i> <i v-on:click="isHidden29 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
            <td class="eddit1 eddit2" v-on:click="isHidden29 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </td>
          </tr>
          
        </tbody>
      </table>
      </div>
    </div>
      </div>





  
  </div>
</div>
<br>
<nav class="navbar navbar-light bg-light">
  <div class="container-fluid font1 font-bold1">
    <span>Other Details</span>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent4" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fa fa-chevron-down" aria-hidden="true"></i>
    </button>
    
  </div>
</nav>
<div class="collapse" id="navbarToggleExternalContent4">
  <div class="bg-light p-4">
    <table class="table font1">
      <tbody>
        
        <tr>
          <td >Created By</td>
          <td v-if="!isHidden13" class="eddit2">  {{ customer.created_by}}</td>
          <td v-else><input class="me-2" v-model="customer.created_by"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden13 = false"></i> <i v-on:click="isHidden13 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
          <td class="eddit1 eddit2" v-on:click="isHidden13 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        <tr>
          <td >Is Company</td>
          <td v-if="!isHidden14" class="eddit2">  {{ customer.is_company}}</td>
          <td v-else><input class="me-2" v-model="customer.is_company"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden14 = false"></i> <i v-on:click="isHidden14 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
          <td class="eddit1 eddit2" v-on:click="isHidden14 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        <tr>
          <td >tparts</td>
          <td v-if="!isHidden15" class="eddit2">  {{ customer.tparts}}</td>
          <td v-else><input class="me-2" v-model="customer.tparts"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden15 = false"></i> <i v-on:click="isHidden15 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
          <td class="eddit1 eddit2" v-on:click="isHidden15 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        <tr>
          <td >Area Agent</td>
          <td v-if="!isHidden16" class="eddit2"> {{ customer.area_agent}}</td>
          <td v-else><input class="me-2" v-model="customer.area_agent"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden16 = false"></i> <i v-on:click="isHidden16 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
          <td class="eddit1 eddit2" v-on:click="isHidden16 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        <tr>
          <td >terms</td>
          <td v-if="!isHidden17" class="eddit2">{{customer.terms}} </td>
          <td v-else><input class="me-2" v-model="customer.terms"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden17 = false"></i> <i v-on:click="isHidden17 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
          <td class="eddit1 eddit2" v-on:click="isHidden17 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        <tr>
        <td >Created Date</td>
        <td v-if="!isHidden18" class="eddit2">  {{ customer.created_at}}</td>
        <td v-else><input class="me-2" v-model="customer.created_at"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden18 = false"></i> <i v-on:click="isHidden18 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
        <td class="eddit1 eddit2" v-on:click="isHidden18 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td>
      </tr>
      <tr>
        <td >Status</td>
        <td v-if="!isHidden19" class="eddit2">  {{ customer.C_status}}</td>
        <td v-else><input class="me-2" v-model="customer.C_status"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden19 = false"></i> <i v-on:click="isHidden19 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
        <td class="eddit1 eddit2" v-on:click="isHidden19 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td>
      </tr> 
      <tr>
        <td >service</td>
        <td  v-if="!isHidden20" class="eddit2">  {{ customer.service}}</td>
        <td v-else><input class="me-2" v-model="customer.service"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden20 = false"></i> <i v-on:click="isHidden20 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
        <td class="eddit1 eddit2" v-on:click="isHidden20 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td>
      </tr>  
      <tr>
        <td >parts</td>
        <td v-if="!isHidden21" class="eddit2">  {{ customer.parts}}</td>
        <td v-else><input class="me-2" v-model="customer.parts"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden21 = false"></i> <i v-on:click="isHidden21 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
        <td class="eddit1 eddit2" v-on:click="isHidden21 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td>
      </tr>
      <tr>
        <td >units</td>
           <td v-if="!isHidden22" class="eddit2">  {{ customer.units}}</td>
           <td v-else><input class="me-2" v-model="customer.units"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden22 = false"></i> <i v-on:click="isHidden22 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
           <td class="eddit1 eddit2" v-on:click="isHidden22 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
           </td> 
      </tr>
      <tr>
        <td >Ag Division</td>
        <td v-if="!isHidden23" class="eddit2">  {{ customer.ag_division}}</td>
        <td v-else><input class="me-2" v-model="customer.ag_division"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden23 = false"></i> <i v-on:click="isHidden23 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
           <td class="eddit1 eddit2" v-on:click="isHidden23 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
           </td> 
      </tr>
      <tr>
        <td >Dealer Discount</td>
        <td v-if="!isHidden24" class="eddit2">  {{ customer.dealer_discount}}</td>
        <td v-else><input class="me-2" v-model="customer.dealer_discount"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden24 = false"></i> <i v-on:click="isHidden24 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
        <td class="eddit1 eddit2" v-on:click="isHidden24 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </td> 
      </tr>
      </tbody>
    </table>
  </div>
</div>
<br>
<nav class="navbar navbar-light bg-light">
  <div class="container-fluid font1 font-bold1">
    <span>CRM Notes</span>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent7" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fa fa-chevron-down" aria-hidden="true"></i>
    </button>
    
  </div>
</nav>
<div class="collapse" id="navbarToggleExternalContent7">
  <div class="bg-light p-4">
    <table class="table font1">
      <tbody>
        <tr>
          <td >CRM notes</td>
          <td class="eddit2">notes </td>
          <td class="eddit1 eddit2"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>

        </tr>
      </tbody>
    </table>
  
  </div>
</div>


<br>




</div>

<div class="col-md-7 container-fluid ps-3">
<!-- Tabs navs -->
<ul class="nav nav-tabs mb-3" id="ex1" role="tablist">
<li class="nav-item" role="presentation">
  <a
    class="nav-link active font1 font-bold1"
    id="ex1-tab-1"
    data-bs-toggle="tab"
    href="#ex1-tabs-1"
    role="tab"
    aria-controls="ex1-tabs-1"
    aria-selected="true"
    >Transaction Summary</a
  >
</li>
<li class="nav-item" role="presentation">
  <a
    class="nav-link font1 font-bold1"
    id="ex1-tab-2"
    data-bs-toggle="tab"
    href="#ex1-tabs-2"
    role="tab"
    aria-controls="ex1-tabs-2"
    aria-selected="false"
    >SO List</a
  >
</li>
<li class="nav-item" role="presentation">
  <a
    class="nav-link font1 font-bold1"
    id="ex1-tab-3"
    data-bs-toggle="tab"
    href="#ex1-tabs-3"
    role="tab"
    aria-controls="ex1-tabs-3"
    aria-selected="false"
    >Invoice List</a
  >
</li>
<li class="nav-item" role="presentation">
  <a
    class="nav-link font1 font-bold1"
    id="ex1-tab-4"
    data-bs-toggle="tab"
    href="#ex1-tabs-2"
    role="tab"
    aria-controls="ex1-tabs-2"
    aria-selected="false"
    >Payments/ Receipts List</a
  >
</li>
</ul>
<!-- Tabs navs -->

<!-- Tabs content -->
<div class="tab-content" id="ex1-content">
<div
  class="tab-pane fade show active"
  id="ex1-tabs-1"
  role="tabpanel"
  aria-labelledby="ex1-tab-1"
>

<div class=" bg-light p-4">
  <table class="table font1 ">
    <tbody>
      <tr>
        <th class="width1" >#</th>
        <th> Invoice/Receipt </th>
        <th>Transaction Date</th>
        <th>Invoice Amount(Rs)</th>
        <th>Paid Amount(Rs)</th>
        <th>Balance(Rs)</th>
      </tr>
      
    </tbody>
  </table>
</div>
</div>
<div class="tab-pane fade" id="ex1-tabs-2" role="tabpanel" aria-labelledby="ex1-tab-2">
  SO List
</div>
<div class="tab-pane fade" id="ex1-tabs-3" role="tabpanel" aria-labelledby="ex1-tab-3">
  Invoice List
</div>
<div class="tab-pane fade" id="ex1-tabs-4" role="tabpanel" aria-labelledby="ex1-tab-2">
  Payments/ Receipts List
</div>
</div>
<!-- Tabs content -->


 
 

</div>
 

        

</div>

  </div> 
    <br>
    <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-5">
                      
      <!-- <Button   class=" btn btn-success" type=""> Conform</Button>
      <button class="btn1 btn btn-danger ">Back</button> -->
     
  </div>


</div>

<button v-on:click="myFunction()">Try it</button>
<div id="myDIV">
  This is my DIV element.
  </div>


  </div>
</template>

<script>
 import authService from '@/auth.service';
 import axios from 'axios';
import httpClient from '@/axios';
import NavView from '../../components/NavView.vue'
    import SideBar from '../../components/SideBar.vue'


export default {

  mounted(){
    this.loadData2(this.$route.query.data);
  },


//   mounted(){
//   if(this.$route.params.id){
//       localStorage.setItem('token',this.$route.params.id);
//   }
 
// this.loadData2(localStorage.getItem('token'));
// },

data(){
  return{
    
    access_token:authService.isLoggedIn(),
    details:'',
    contact_length:'',
    
    isHidden: false,
    isHidden1: false,
    isHidden2: false,
    isHidden3: false,
    isHidden4: false,
    isHidden5: false,
    isHidden6: false,
    isHidden7: false,
    isHidden8: false,
    isHidden9: false,
    isHidden10: false,
    isHidden11: false,
    isHidden12: false,
    isHidden13: false,
    isHidden14: false,
    isHidden15: false,
    isHidden16: false,
    isHidden17: false,
    isHidden18: false,
    isHidden19: false,
    isHidden20: false,
    isHidden21: false,
    isHidden22: false,
    isHidden23: false,
    isHidden24: false,
    isHidden25: false,
    isHidden26: false,
    isHidden27: false,
    isHidden28: false,
    isHidden29: false,
    isHidden30: false,

    'address': {
      'address_line_1': '',
      'address_line_2': '',
      'address_line_3': '',
    },
    'create': {
      'name': '',
      'designation': '',
      'email': '',
      'tel': '',
    },

    'contact':[ 
    
    ],
      
    
    'bank': {
     
      'bank_name': '',
      'branch': '',
      'acount_num': '',
    },
    
    'customer': {
      'idCustomer':this.$route.query.data,
      'C_name':'',
      'C_code':'',
      'customer_type':'',
      'C_firstname':'',
      'C_lastname':'',
      'C_contact_tel1':'',
      'C_email':'',
      'C_designation':'',
      'nic_no':'',
      'driving_license':'',
      'C_contact_person':'',
     
      'district':'',
     
      'created_by':'',
      'is_company':'',
      'tparts':'',
      'area_agent':'',
      'terms':'',
      'created_at':'',
      'C_status':'',
      'service':'',
      'parts':'',
      'units':'',
      'ag_division':'',
      'dealer_discount':'',
      
    },
    'idCustomer':this.$route.query.data,
  }
},

components:{
  NavView,SideBar
},



methods:{

  

  myFunction() {
  var x = document.getElementById("myDIV");
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
},

  async Delete(id){
      // console.log(this.address); 
    // console.log(this.id);
    await httpClient.post('web/mcustomer/delete2',{id:id}).then(
        response => {
          console.log(response);
        //  this.errors = response.data.success;
        //this.$refs.table.innerHTML = response.data.success;
            window.location.reload();
          
        }
       
       )
     
    },

    async Create(id1){
      // console.log(this.address); 
    // console.log(this.id);
    await httpClient.post('web/mcustomer/create2',{id:id1, create:this.create}).then(
        response => {
          console.log(response);
        //  this.errors = response.data.success;
        //this.$refs.table.innerHTML = response.data.success;
            window.location.reload();
          
        }
       
       )
      //  axios.post('http://localhost/vrs_vuejs_new/basic/web/mcustomer/update2?data='+id,this.address).then(
      //   response => {
      //     console.log(response);
      //   //  this.errors = response.data.success;
      //   //this.$refs.table.innerHTML = response.data.success;
      //    
          
      //   }
       
      //  )
    },

  
    async update4(id2){
      // console.log(this.address); 
    // console.log(this.id);
    await httpClient.post('web/mcustomer/update4',{id:id2, bank:this.bank}).then(
        response => {
          console.log(response);
        //  this.errors = response.data.success;
        //this.$refs.table.innerHTML = response.data.success;
           window.location.reload();
          
        }
       
       )
      //  axios.post('http://localhost/vrs_vuejs_new/basic/web/mcustomer/update2?data='+id,this.address).then(
      //   response => {
      //     console.log(response);
      //   //  this.errors = response.data.success;
      //   //this.$refs.table.innerHTML = response.data.success;
          // window.location.reload();
          
      //   }
       
      //  )
    },



    async update3(id1){
      // console.log(this.address); 
    // console.log(this.id);
    await httpClient.post('web/mcustomer/update3',{id:id1, contact:this.contact}).then(
        response => {
          console.log(response);
        //  this.errors = response.data.success;
        //this.$refs.table.innerHTML = response.data.success;
         //  window.location.reload();
          
        }
       
       )
      //  axios.post('http://localhost/vrs_vuejs_new/basic/web/mcustomer/update2?data='+id,this.address).then(
      //   response => {
      //     console.log(response);
      //   //  this.errors = response.data.success;
      //   //this.$refs.table.innerHTML = response.data.success;
      //     // window.location.reload();
          
      //   }
       
      //  )
    },



    async update(id){
      // console.log(this.address); 
    // console.log(this.id);
    await httpClient.post('web/mcustomer/update2',{id:id, address:this.address}).then(
        response => {
          console.log(response);
        //  this.errors = response.data.success;
        //this.$refs.table.innerHTML = response.data.success;
            window.location.reload();
          
        }
       
       )
      //  axios.post('http://localhost/vrs_vuejs_new/basic/web/mcustomer/update2?data='+id,this.address).then(
      //   response => {
      //     console.log(response);
      //   //  this.errors = response.data.success;
      //   //this.$refs.table.innerHTML = response.data.success;
      //     // window.location.reload();
          
      //   }
       
      //  )
    },


     loadData2(userid) {
   
   console.log(userid); 
   axios.get('/web/api/mcustomer/view?id='+userid ,{
    headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       }).then(
      response => {
        console.log(response);
       

       this.details = response.data.address;
        
      
         // this.details3 = response.data.address;
        
          this.customer = response.data.item_list;
          this.details4 = response.data.contacts;
          this.details5 = response.data.bankdet;
          this.contact_length = response.data.contacts.length;
        
      
          console.log('amila thilanka');
    console.log(this.contact_length);
    for(let i = 1; i <= this.contact_length; i++){
    this.contact.push({},);
    }
      //this.$refs.table.innerHTML = response.data.success;
        // window.location.reload();
        
      }
     
     )
    
    
     
 

  } ,

 

   save(){
    console.log(this.$route.query.data);
    axios.post('/web/api/mcustomer/edit?id='+this.$route.query.data, {customer:this.customer},{
    headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       }).then(
        response => {
          console.log(response);
        }
       )

  },
 





}
}

</script>

<style scoped>
  .width1{
      width: 15%;
  }

  .btn1 {
      padding-left: 18px;
      padding-right: 18px;
  }
  
  td{
   padding: 2px;
   

  }
  .font1{
    font-size: 13px !important;
 
  }
  .font-bold1{
    font-weight: bold;
  }
  .clr2 {
      background-color: #AED8F2;
      padding: 2px;
      border-radius: 3px
  }
  .decoration{
    text-decoration: none;
    color:#A5A5A3  ;
  }

  .hmy{
    color: black;
  }

  .border1{
    border-bottom: #E9E9E3 solid 2px;
    border-top: #E9E9E3 solid 2px;
    padding: 2px;
  }
  .eddit1{
    
    display: none;
  }
  .eddit1:hover{
    cursor: pointer;
  }
  
  .eddit2:hover  + .eddit1, .eddit1:hover{
    display: inline-table !important;
    margin-top: 5px;
  }
  .hiden2{
    display: none;
  }
  .nav-link{
    color: black !important;
  }
  .nav-link:focus{
    color: blue !important;
  }
  .nav-link.active{
    color: blue !important;
  }
  .border-radius0{
    border-radius:0px !important ;
  }
  .pointer1:hover{
    cursor: pointer;
  }
  .width2{
    width: 12%;
  }
  .width3{
    width: 25% !important;
  }
  .width4{
    width: 100px;
  }
 
  
</style>